import FleetCoachDriverMappingApi from "../../services/api/FleetCoachDriverMapping";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";

function handleError(err) {
  console.log("error in list fleet coach driver mapping:", err);
}

export const setFleetCoachDriverMappingList = (payload) => {
  return {
    type: ActionTypes.SET_FLEET_COACH_DRIVER_MAPPING_LIST,
    payload,
  };
};

export const setFleetCoachDriverMappingActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_FLEET_COACH_DRIVER_MAPPING_ACTIVE_FILTERS,
    payload,
  };
};

export const getFleetCoachDriverMappingList =
  (filters = [], pageRequest = {}) =>
  async (dispatch) => {
    try {
      let body = {
        page_request: pageRequest,
        filters: filters,
      };

      dispatch(setLoader(true));
      let response =
        await FleetCoachDriverMappingApi.getFleetCoachDriverMappingList(body);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setFleetCoachDriverMappingList(response));
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
